export type CertificateHealth = {
  color: 'success' | 'warning' | 'danger' | 'secondary';
  label: string;
};

export function getCertificateHealth(
  certificate: { status: string; validUntil?: string },
  now = Date.now(),
): CertificateHealth {
  if (certificate.status === 'expired') return { color: 'danger', label: 'Expired' };
  if (certificate.status === 'invalid') return { color: 'danger', label: 'Invalid certificate' };
  if (certificate.status !== 'valid') {
    return { color: 'secondary', label: certificate.status === 'unreachable' ? 'Unreachable' : 'Not configured' };
  }

  const expiresAt = certificate.validUntil ? Date.parse(certificate.validUntil) : NaN;
  if (!Number.isFinite(expiresAt)) return { color: 'secondary', label: 'Expiry unknown' };
  if (expiresAt <= now) return { color: 'danger', label: 'Expired' };

  const remainingDays = (expiresAt - now) / 86_400_000;
  const label = `${Math.floor(remainingDays)} days left`;
  if (remainingDays < 7) return { color: 'danger', label };
  if (remainingDays < 15) return { color: 'warning', label };
  return { color: 'success', label };
}
